import React from 'react'
import logo from './Assets/Images/exitfund.svg'
import page404 from './Assets/Images/page404.svg'
import './ErrorBoundary.scss'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    if (
      error?.name === 'ChunkLoadError' ||
      error?.message?.includes('Loading chunk') ||
      error?.message?.includes('Loading CSS chunk') ||
      error?.message?.includes('ChunkLoadError')
    ) {
      // A JS or CSS chunk failed to load — almost always a stale tab after a new deploy.
      // Hard-refresh once to pull the current index.html + chunk hashes. Guard against a
      // reload loop in case the chunk is genuinely missing (max one reload per 10s).
      const now = Date.now()
      const lastReload = Number(sessionStorage.getItem('chunk_reload_ts') || 0)
      if (now - lastReload > 10000) {
        console.warn('ChunkLoadError detected. Reloading application...')
        sessionStorage.setItem('chunk_reload_ts', String(now))
        window.location.reload(true) // hard refresh
        return
      }
      // Reloaded very recently and still failing → fall through to the error UI instead of looping.
    }

    // Log error to state
    this.setState({ error, errorInfo })
    // Send error to backend for logging
    this.logErrorToService(error, errorInfo)
  }

  logErrorToService = async (error, errorInfo) => {
    const hostname = window.location.hostname
    let BASE_URL = ''

    if (hostname === 'admin.exitfund.com') {
      BASE_URL = 'https://api.exitfund.com'
    } else if (hostname === 'admin.stg.exitfund.com') {
      BASE_URL = 'https://api.stg.exitfund.com'
    } else {
      BASE_URL = 'http://127.0.0.1:7000'
    }

    const errorDetails = {
      error: error.toString(),
      stack: errorInfo.componentStack,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      url: window.location.href,
    }
    // console.log({ errorDetails })
    try {
      await fetch(`${BASE_URL}/error/frontend-error-logger`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(errorDetails),
      })
    } catch (err) {
      console.error('Failed to send error log to server:')
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="errorPage">
          <div className="errorPage-header">
            <img src={logo} alt="ExitFund" />
          </div>
          <div className="errorPage-content">
            <div className="left">
              <h1 className="error-x">ERROR</h1>
              <h2 className="title-x">Something Broke</h2>
              <p className="subtitle-x">
                An unexpected error occurred in the app. Refresh and try again.
              </p>
            </div>
            <div className="right">
              <img src={page404} alt="error illustration" />
            </div>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
